import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import RootHome from './RootHome';

function DefaultRedirect() {
  const DEFAULT_COUNTRY = 'canada';
  const [isPrerendering, setIsPrerendering] = useState(false);
  
  // Move localStorage access to useEffect to avoid hydration mismatches
  useEffect(() => {
    // Check if this is a prerendering environment
    if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') {
      setIsPrerendering(true);
    }
    
    // Only access localStorage after component mounts (client-side only)
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('selectedCountry', DEFAULT_COUNTRY);
    }
  }, []);
  
  // During prerendering, render the RootHome component for SEO
  if (isPrerendering) {
    return <RootHome />;
  }
  
  // During normal browsing, redirect to Canada home page
  return <Navigate to={`country/${DEFAULT_COUNTRY}/home`} replace />;
}

export default DefaultRedirect;
